import React, { useState, useEffect } from "react";
import { useParams, Navigate } from "react-router-dom";
import { Modal, Button, Input } from "antd";
import "./editProfile.css";
import apiClient from "../../api/apiClient";
import { useToast } from "../../context/toastContext";
import { useConfirm } from "../../context/confirmContext";
import useUnsavedChanges from "../../hooks/useUnsavedChanges";

function EditProfile({
    instagram,
    setInstagram,
    facebook,
    setFacebook,
    website,
    setWebsite,
    twitter,
    setTwitter,
    linkedin,
    setLinkedin,
    profilePic,
    setProfilePic,
    userId,
    description,
    setDescription,
    images,
    licenseNo,
    setImages,
    toggleProfile,
    setShowEditProfile,
    setShowProfile,
}) {
    const toast = useToast();
    const confirmDialog = useConfirm();
    const [isModalVisible, setIsModalVisible] = useState(false);
    const [updated, setUpdated] = useState(false);
    const [APIKEY, setAPIKEY] = useState("");
    const [saving, setSaving] = useState(false);

    useUnsavedChanges(updated);

    //shows pop up for description
    const showModal = () => {
        setIsModalVisible(true);
    };

    const handleOk = async () => {
        setIsModalVisible(false);
    };

    //handles canceling Description
    const handleCancel = () => {
        setIsModalVisible(false);
    };

    const uploadImages = async (event) => {
        setUpdated(true);
        const files = event.target.files;
        const formData = new FormData();

        if (images.length < 6) {
            for (let i = 0; i < 6 - images.length; i++) {
                formData.append("files", files[i]);
            }

            if (files.length + images.length > 6) {
                let remainingImages = 6 - images.length;
                toast.warning("Only six images available for your profile. Uploading " + remainingImages + " image(s)");
            }

            const response = await apiClient.post(`/user/upload-company-pics`, {
                method: "POST",
                body: formData,
            });

            if (!response.ok) {
                throw new Error(`HTTP error! status: ${response.status}`);
            }

            const data = await response.data;
            setImages((prevImages) => [...prevImages, ...data.imageUrls]);
            setUpdated(true);
        } else {
            toast.warning("You can only upload up to six images to your profile");
        }
    };

    const handleImageUpload = async (event) => {
        const file = event.target.files[0];
        const formData = new FormData();
        formData.append("file", file);
        formData.append("userId", userId);

        try {
            const response = await apiClient.post(`/user/upload-profile-pic`, formData, {
                headers: {
                    "Content-Type": "multipart/form-data",
                },
            });

            setProfilePic(response.data.imageUrl);
            console.log(profilePic);
        } catch (error) {
            console.error("Error uploading image:", error);
        }
        setUpdated(true);
    };

    async function handleImageDelete(image, userId) {
        const ok = await confirmDialog({
            title: "Delete Image",
            message: "Are you sure you want to delete this image?",
            confirmLabel: "Delete",
            variant: "danger",
        });
        if (!ok) return;
        setImages((prevImages) => prevImages.filter((img) => img !== image));
        deleteImage(image, userId);
    }

    function deleteImage(image, licenseNo) {
        // Send a DELETE request to the backend to delete the image.
        apiClient.delete(
            `/license/delete-image?image=${encodeURIComponent(image)}&licenseNo=${encodeURIComponent(licenseNo)}`,
            {
                method: "DELETE",
            }
        )
            .then((response) => {
                if (!response.ok) {
                    throw new Error("Network response was not ok");
                }
                // Handle the response here.
            })
            .catch((error) => {
                console.error("There has been a problem with your fetch operation:", error);
            });
    }

    const setAPIKEYHandler = async () => {
        const response = await apiClient.post(`/user/setAPIKEY`, { APIKEY: APIKEY, userId: userId });
    };

    const handleSubmit = async (event) => {
        event.preventDefault();
        setSaving(true);
        setUpdated(false);

        try {
            const profileData = {
                description: description,
                instagram: instagram,
                facebook: facebook,
                website: website,
                twitter: twitter,
                linkedin: linkedin,
                profilePic: profilePic,
                images: images,
                licenseNo: licenseNo,
            };

            const response = await apiClient.post(`/license/editprofile`, {
                profileData,
            });

            const data = await response.data;

            if (data.success) {
                toast.success("Profile updated successfully");
                setShowEditProfile(false);
                setShowProfile(true);
            }
        } catch (error) {
            toast.error("Failed to save profile changes.");
        } finally {
            setSaving(false);
        }
    };

    return (
        <div className="profile-container fade-down">
            <form onSubmit={handleSubmit} className="edit-profile-form">
                {/* <h1 className="edit-profile-title">Edit Profile</h1> */}
                <div className="edit-profile-pictures">
                    <h3>Logo</h3>
                    <label htmlFor="file-input">
                        {!profilePic && (
                            <img
                                src="/ProfilePicDefault.svg"
                                title="Add Profile Picture"
                                alt="Profile"
                                className="profile-pic-1"
                            />
                        )}
                        {profilePic && (
                            <div className="image-upload">
                                <img
                                    src={profilePic}
                                    alt="Profile"
                                    title="Change Profile Picture"
                                    className="profile-pic-1"
                                />
                            </div>
                        )}
                    </label>
                    <input id="file-input" type="file" onChange={handleImageUpload} style={{ display: "none" }} />
                </div>
                <div className="edit-profile-information">
                    <h3>Profile Information:</h3>
                    <div className="edit-profile-link">
                        <strong>LinkedIn:</strong>
                        <input
                            className="edit-profile-input"
                            type="url"
                            name="linkedin"
                            value={linkedin}
                            onChange={(e) => {
                                setLinkedin(e.target.value);
                                setUpdated(true);
                            }}
                        />
                    </div>
                    <div className="edit-profile-link">
                        <strong>Instagram:</strong>
                        <input
                            className="edit-profile-input"
                            type="url"
                            name="instagram"
                            value={instagram}
                            onChange={(e) => {
                                setInstagram(e.target.value);
                                setUpdated(true);
                            }}
                        />
                    </div>
                    <div className="edit-profile-link">
                        <strong>Twitter:</strong>
                        <input
                            className="edit-profile-input"
                            value={twitter}
                            type="url"
                            name="twitter"
                            onChange={(e) => {
                                setTwitter(e.target.value);
                                setUpdated(true);
                            }}
                        />
                    </div>

                    <div className="edit-profile-link">
                        <strong>Facebook:</strong>
                        <input
                            className="edit-profile-input"
                            type="url"
                            name="facebook"
                            value={facebook}
                            onChange={(e) => {
                                setFacebook(e.target.value);
                                setUpdated(true);
                            }}
                        />
                    </div>
                    <div className="edit-profile-link">
                        <strong>Company Website:</strong>
                        <input
                            className="edit-profile-input"
                            type="url"
                            name="companyWebsite"
                            value={website}
                            onChange={(e) => setWebsite(e.target.value)}
                        />
                    </div>
                    <button
                        type="button"
                        onClick={showModal}
                        className="EditBioButton"
                        style={{ marginBottom: "3vh", marginTop: "3vh" }}
                    >
                        Edit Bio
                    </button>
                    <Modal
                        okButtonProps={{ style: { backgroundColor: "green", color: "white" } }}
                        cancelButtonProps={{ style: { backgroundColor: "red", color: "white" } }}
                        title="Update Bio"
                        open={isModalVisible}
                        onOk={handleOk}
                        bodyStyle={{}}
                        onCancel={handleCancel}
                    >
                        <textarea
                            value={description}
                            onChange={(e) => setDescription(e.target.value)}
                            style={{ height: "15vh", minWidth: "100%", maxWidth: "100%", color: "black" }}
                        />
                    </Modal>
                    <div
                        style={{
                            display: "flex",
                            justifyContent: "center",
                            position: "absolute",
                            bottom: "75px",
                            right: "20px",
                        }}
                    >
                        <button type="submit" value="Save Changes" className="employeeButton" disabled={saving}>
                            {saving ? "Saving…" : "Save Changes"}
                        </button>
                    </div>
                    <div
                        style={{
                            display: "flex",
                            justifyContent: "center",
                            position: "absolute",
                            bottom: "20px",
                            right: "20px",
                        }}
                    >
                        <button
                            onClick={async () => {
                                if (updated) {
                                    const leave = await confirmDialog({
                                        title: "Unsaved Changes",
                                        message: "You have unsaved changes. Are you sure you want to cancel?",
                                        confirmLabel: "Discard",
                                        cancelLabel: "Keep Editing",
                                        variant: "danger",
                                    });
                                    if (!leave) return;
                                }
                                toggleProfile();
                            }}
                            className="employeeButton"
                        >
                            Cancel
                        </button>
                    </div>
                </div>
            </form>
        </div>
    );
}

export default EditProfile;
